/**
 * MAGSDK basic implementation of spvr plugin.
 *
 * @author Fedotov D. <bas.jsdev@gmail.com>
 */

'use strict';


var Emitter        = require('cjs-emitter'),
    gettextWrapper = require('mag-gettext'),
    apiConst       = require('magcore-plugin-content-board'),
    providerDaemon = {},
    stateToText    = ['', 'Scheduled recording', 'Recording', 'Recording error!', 'Recorded'],
    provider       = new Emitter(),
    daemon         = new Emitter(),
    gettext;


daemon.list = [];

daemon.addItem = function ( item ) {
    var weHaveIt = daemon.list.some(function ( oldItem ) {
        return oldItem.id === item.id;
    });

    if ( !weHaveIt && provider.api ) {
        daemon.list.push(item);
        // add new item in provider list
        providerDaemon.addItem(item);
    }
};

daemon.removeItem = function ( item ) {
    var weHadIt = daemon.list.some(function ( oldItem, ind ) {
        if ( oldItem.id === item.id ) {
            daemon.list.splice(ind, 1);
            return true;   // eslint-disable-line
        } else {           // eslint-disable-line
            return false;  // eslint-disable-line
        }
    });

    if ( weHadIt && provider.api ) {
        // tell provider to remove item
        providerDaemon.removeItem(item);
    }
};


function Client () {
    var self = this;

    Emitter.call(this);

    this.updateTime = 6500;
    this.records = [];
    this.hash = {};
    this.timerId = null;
    this.enabled = !!MODE_STALKER;

    // set hidden fields
    Object.defineProperties(this, {
        list: {
            get: function () {
                return self.records;
            },
            set: function () { return false; }
        },
        updateInterval: {
            get: function () {
                return self.updateTime;
            },
            set: function ( newTime ) {
                self.updateTime = newTime;
                clearInterval(self.timerId);
                if ( !self.enabled ) { return; }
                self.timerId = setInterval(self.update, self.updateTime);
            }
        }
    });

    // first launch
    this.update();

    // check info and trigger events if something was changed
    this.timerId = setInterval(
        (function ( myself ) {
            return function () {
                myself.update();
            };
        })(this),
        self.updateTime
    );
}


Client.prototype = Object.create(Emitter.prototype);
Client.prototype.constructor = Client;


Client.prototype.errorCodes = {
    '-1': 'Wrong channel id.',
    '-2': 'Server error.',
    '-3': 'Wrong server record object.',
    '-4': 'Server api not available.'
};

Client.prototype.states = {
    WAITING: 1,
    RECORDING: 2,
    ERROR: 3,
    FINISHED: 4
};

Client.prototype.errors = {
    // Wrong channel id
    WRONG_ID: '-1',
    // Server error
    SERVER_ERROR: '-2',
    // Wrong server record object
    WRONG_RECORD_OBJECT: '-3',
    // Server api not available
    API_NOT_AVAILABLE: '-4'
};


// make it's states compatible with local pvr
// original server codes: 0 - waiting, 1 - recording, 2 - finished
Client.prototype.status = {0: 1, 1: 2, 2: 4};


/**
 * Add new record.
 * @param {Object} data record info
 * @param {string} data.id channel id at server
 * @param {number} data.startTime start time
 * @param {number} data.endTime end time
 * @param {function} callback callback
 *
 * @example
 * spvr.add({
 *     id: 14,
 *     startTime: Math.ceil((new Date()).getTime() / 1000 + 10),
 *     endTime: Math.ceil((new Date()).getTime() / 1000 + 500)
 * }, function ( error, data ) {
 *     console.log(error);
 *     console.log(data);
 * });
 */
Client.prototype.add = function ( data, callback ) {
    var self = this,
        body;

    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !data.id ) {
        callback({code: this.errors.WRONG_ID, message: this.errorCodes[this.errors.WRONG_ID]});

        return;
    }
    if ( !this.enabled ) {
        callback({code: this.errors.API_NOT_AVAILABLE, message: this.errorCodes[this.errors.API_NOT_AVAILABLE]});

        return;
    }
    /* eslint-disable */
    body = {ch_id: data.id};
    if ( data.startTime ) {
        body.start_time = data.startTime;
    }
    if ( data.endTime ) {
        body.end_time = data.endTime;
    }
    /* eslint-enable */

    core.backend.request('recordings', {
        version: 3,
        method: 'POST',
        body: JSON.stringify(body),
        onload: function ( error, response ) {
            var serverData, item;

            if ( error ) {
                try {
                    response = JSON.parse(response).message;
                } catch ( errorText ) {
                    response = errorText;
                }

                callback({code: self.errors.SERVER_ERROR, message: response});
            } else {
                serverData = response.data;
                item = new Emitter();
                item.serverData = {
                    id: serverData.id,
                    state: self.states.WAITING,
                    url: '',
                    path: '',
                    channel: serverData.ch_name,
                    channelId: serverData.ch_id,
                    name: serverData.name || (serverData.ch_name + ' ' + serverData.id),
                    startTime: serverData.start_time,
                    endTime: serverData.end_time,
                    progress: 0,
                    server: true,
                    downloadable: serverData.downloadable
                };

                item.states = self.states;

                item.stop = function ( stopCallback ) {
                    core.backend.request('recordings/' + this.data.id + '/stop', {
                        version: 3,
                        method: 'PUT',
                        onload: function ( error, onloadResponse ) {
                            if ( error ) {
                                stopCallback({
                                    code: self.errors.SERVER_ERROR,
                                    message: self.errorCodes[self.errors.SERVER_ERROR]
                                });
                            } else if ( onloadResponse && onloadResponse.data && !onloadResponse.error ) {
                                if ( self.events['stop'] ) {
                                    self.emit('stop', {item: this, time: (new Date()).getTime()});
                                }
                                stopCallback(null, true);
                            } else {
                                stopCallback({
                                    code: self.errors.SERVER_ERROR,
                                    message: self.errorCodes[self.errors.SERVER_ERROR]
                                });
                            }
                        },
                        onerror: function () {
                            console.log('spvr.add onerror');
                        }
                    });
                };

                self.hash[item.data.id] = item;
                self.records.push(item);
                daemon.addItem(item.data);
                if ( self.events['add'] ) {
                    self.emit('add', {item: item, time: (new Date()).getTime()});
                }
                callback(null, true);
            }
        },
        onerror: function () {
            console.log('spvr.add onerror');
        }
    });
};


/**
 * Remove record
 * @param {Emitter} item record instance
 * @param {function} callback callback
 */
Client.prototype.remove = function ( item, callback ) {
    var self = this;

    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !this.enabled ) {
        callback({code: this.errors.API_NOT_AVAILABLE, message: this.errorCodes[this.errors.API_NOT_AVAILABLE]});

        return;
    }
    if ( !item || !(item instanceof Emitter) ) {
        callback({code: this.errors.WRONG_RECORD_OBJECT, message: this.errorCodes[this.errors.WRONG_RECORD_OBJECT]});

        return;
    }

    core.backend.request('recordings/' + item.data.id, {
        version: 3,
        method: 'DELETE',
        onload: function ( error, response ) {
            if ( error ) {
                try {
                    response = JSON.parse(response).message;
                } catch ( parseError ) {
                    response = parseError;
                }
                //console.log(response);

                callback({
                    code:    self.errors.SERVER_ERROR,
                    message: self.errorCodes[self.errors.SERVER_ERROR]
                });
            } else if ( response && response.data && !response.error ) {
                delete self.hash[item.data.id];
                daemon.removeItem((self.records.splice(self.records.indexOf(item), 1))[0].data);
                if ( self.events['remove'] ) {
                    self.emit('remove', {item: item, time: (new Date()).getTime()});
                }
                callback(null, true);
            } else {
                callback({
                    code:    self.errors.SERVER_ERROR,
                    message: self.errorCodes[self.errors.SERVER_ERROR]
                });
            }
        },
        onerror: function () {
            console.log('spvr->remove->onerror');
        }
    });
};


/**
 * Get record file url for downloading
 * @param {Emitter} item record instance
 * @param {function} callback callback
 */
Client.prototype.getFileUrl = function ( item, callback ) {
    var self = this;

    if ( typeof callback !== 'function' ) {
        console.log('Wrong callback function.');

        return;
    }
    if ( !this.enabled ) {
        callback({
            code:    this.errors.API_NOT_AVAILABLE,
            message: this.errorCodes[this.errors.API_NOT_AVAILABLE]
        });

        return;
    }
    if ( !item || !(item instanceof Emitter) ) {
        callback({
            code:    this.errors.WRONG_RECORD_OBJECT,
            message: this.errorCodes[this.errors.WRONG_RECORD_OBJECT]
        });

        return;
    }

    core.backend.request('recordings/' + item.data.id + '/link', {
        version: 3,
        method: 'GET',
        onload: function ( error, response ) {
            if ( error ) {
                try {
                    response = JSON.parse(response).message;
                } catch ( parseError ) {
                    response = parseError;
                }
                //console.log(response);

                callback({code: self.errors.SERVER_ERROR, message: self.errorCodes[self.errors.SERVER_ERROR]});
            } else if ( response.data && response.data.url ) {
                console.log('spvr->get->url:' + response.data.url);
                callback(null, {url: response.data.url, mediaId: response.data.media_id});
            } else {
                callback({code: self.errors.SERVER_ERROR, message: self.errorCodes[self.errors.SERVER_ERROR]});
            }
        },
        onerror: function () {
            console.log('spvr.url onerror');
        }
    });
};


/**
 * Reset list. All current server records will be marked as new and corresponding events will be emitted.
 */
Client.prototype.reset = function () {
    this.records = [];
    this.hash = {};
    this.update();
};

/**
 * Stop plugin and remove all it listeners. Use it for cleanup before app exit.
 */
Client.prototype.destroy = function () {
    this.events = {};
    this.records = [];
    this.hash = {};
    clearInterval(this.timerId);
};

/**
 * Check for changes. If there are some emit corresponding events. To set new time interval use "updateInterval" property
 *
 * @param {function} callback use it if you need to know when data will be updated and ready for use
 *
 * @example
 * this.updateInterval = 999;
 */
Client.prototype.update = function ( callback ) {
    var self = this;

    if ( !this.enabled ) {
        clearInterval(this.timerId);

        return;
    }

    core.backend.request('recordings', {
        version: 3,
        method: 'GET',
        onload: function ( error, response ) {
            var rawData, ind, item, progress, data;

            if ( error ) {
                console.log('spvr->update->error');
                console.log(error);
                console.log(response);
            } else {
                try {
                    rawData = response.data;
                } catch ( error ) {
                    console.log('spvr->update->parsing error ' + error);
                    rawData = [];
                }

                for ( ind = 0; ind < rawData.length; ind++ ) {
                    // if new item, trigger event
                    if ( self.hash[rawData[ind].id] ) {
                        //console.log('hash has such id, it state:' + status[rawData[ind].status]);
                        item = self.hash[rawData[ind].id];
                        // check if progress changed (every running and finished task -
                        // because of async API, we need to sync progress and state separately)
                        if ( self.status[rawData[ind].status] === 2 || self.status[rawData[ind].status] === 4 ) {
                            progress = Math.ceil(((((new Date()).getTime() / 1000) - rawData[ind].start_time) /
                                (rawData[ind].end_time - rawData[ind].start_time)) * 100);
                            progress = progress < 0 ? 0 : progress;
                            progress = progress > 100 ? 100 : progress;
                            if ( progress !== item.data.progress ) {
                                item.data.progress = progress;
                                self.records[self.records.indexOf(item)].data.progress = progress;
                                // tell provider to update item progress
                                providerDaemon.emitProgress(item);
                                if ( self.events['progress'] ) {
                                    self.emit('progress', {item: item, time: (new Date()).getTime()});
                                    console.log('progress->id:' + rawData[ind].id);
                                }
                            }
                        }
                        // check if state changed
                        if ( self.status[rawData[ind].status] !== item.data.state ) {
                            item.data.state = self.status[rawData[ind].status];
                            item.data.downloadable = rawData[ind].downloadable;
                            self.records[self.records.indexOf(item)].data.state = self.status[rawData[ind].status];
                            self.records[self.records.indexOf(item)].data.downloadable = rawData[ind].downloadable;
                            // tell provider to update item status
                            providerDaemon.emitChange(item);
                            if ( self.events['state'] ) {
                                self.emit('state', {item: item, time: (new Date()).getTime()});
                                console.log('spvr->status->id:' + rawData[ind].id);
                            }
                        }
                    } else {
                        data = rawData[ind];
                        item = new Emitter();
                        item.data = {
                            id: data.id,
                            state: self.status[data.status],
                            url: '',
                            path: '',
                            channel: data.ch_name,
                            channelId: data.ch_id,
                            name: data.name || (data.ch_name + ' ' + data.id),
                            startTime: data.start_time,
                            endTime: data.end_time,
                            progress: 0,
                            server: true,
                            downloadable: data.downloadable
                        };

                        progress = Math.ceil(((((new Date()).getTime() / 1000) - data.start_time) / (data.end_time - data.start_time)) * 100);
                        progress = progress < 0 ? 0 : progress;
                        progress = progress > 100 ? 100 : progress;
                        item.data.progress = progress;

                        item.states = {
                            /** @const {number} */
                            WAITING: 1,
                            /** @const {number} */
                            RECORDING: 2,
                            /** @const {number} */
                            FINISHED: 4,
                            /** @const {number} */
                            ERROR: 3
                        };

                        item.stop = function ( stopCallback ) {
                            core.backend.request('recordings/' + this.data.id + '/stop', {
                                version: 3,
                                method: 'PUT',
                                onload: function ( error, onloadResponse ) {
                                    if ( error ) {
                                        stopCallback({
                                            code: self.errors.SERVER_ERROR,
                                            message: self.errorCodes[self.errors.SERVER_ERROR]
                                        });
                                    } else if ( onloadResponse && onloadResponse.data && !onloadResponse.error ) {
                                        if ( self.events['stop'] ) {
                                            self.emit('stop', {item: this, time: (new Date()).getTime()});
                                        }
                                        stopCallback(null, true);
                                    } else {
                                        stopCallback({
                                            code: self.errors.SERVER_ERROR,
                                            message: self.errorCodes[self.errors.SERVER_ERROR]
                                        });
                                    }
                                },
                                onerror: function () {
                                    console.log('spvr.add onerror');
                                }
                            });
                        };

                        self.hash[item.data.id] = item;
                        self.records.push(item);
                        daemon.addItem(item.data);
                        if ( self.events['add'] ) {
                            self.emit('add', {item: item, time: (new Date()).getTime()});
                        }
                    }
                }
            }
            if ( typeof callback === 'function' ) {
                callback();
            }
        },
        onerror: function ( data ) {
            console.log('spvr->update->onerror');
            console.log(data);
            if ( typeof callback === 'function' ) {
                callback();
            }
        }
    });
};


providerDaemon = {
    /**
     * No need for this daemon so turn it off
     */
    isActive: false,
    /**
     * Hash to connect raw records data and records objects. Otherwise on each update operation we should
     * use multiple cycles to build connections between raw data and record objects and only then apply changes.
     *
     * @type {Object}
     */
    idToIndexHash: {},
    /**
     * Array of all records from all apps.
     */
    list: [],
    /**
     * Provider should imitate application to be able to listen for all records updates.
     */
    client: null,
    /**
     * Synchronise changes in records on gSTB level and if there are some - trigger corresponding callbacks in clients.
     *
     * @param {Object} item record wrapped record
     */
    emitChange: function ( item ) {
        try {
            providerDaemon.idToIndexHash[item.id].data.state = stateToText[item.state];
            if ( providerDaemon.idToIndexHash[item.id].events['stop'] ) {
                providerDaemon.idToIndexHash[item.id].emit('change');
            }
        } catch ( error ) {
            console.log('pvr provider: error in one of "add" listeners. ' + error);
        }
    },
    emitProgress: function ( item ) {
        try {
            providerDaemon.idToIndexHash[item.id].data.progress = item.progress;
            if ( providerDaemon.idToIndexHash[item.id].events['change'] ) {
                providerDaemon.idToIndexHash[item.id].emit('change');
            }
        } catch ( error ) {
            console.log('pvr provider: error in one of "add" listeners. ' + error);
        }
    },
    addItem: function ( item ) {
        var wrapped = new Emitter();

        wrapped.id = item.id;
        wrapped.layout = apiConst.layouts.record;
        wrapped.geometry = apiConst.geometry.horizontal;
        wrapped.data = {
            name: item.name,
            progress: item.progress,
            state: stateToText[item.state],
            url: function ( callback ) {
                provider.getUrl(item.id, callback);
            },
            mime: 'content/video'
        };

        providerDaemon.idToIndexHash[item.id] = wrapped;
        providerDaemon.list.push(wrapped);

        try {
            if ( provider.events['add'] ) {
                provider.emit('add', [wrapped]);
            }
        } catch ( error ) {
            console.log('pvr provider: error in one of "add" listeners. ' + error);
        }
    },
    removeItem: function ( item ) {
        var deleted = providerDaemon.list.splice(providerDaemon.list.indexOf(providerDaemon.idToIndexHash[item.id]), 1);

        delete providerDaemon.idToIndexHash[item.id];

        try {
            if ( provider.events['remove'] ) {
                provider.emit('remove', deleted);
            }
        } catch ( error ) {
            console.log('pvr provider: error in one of "remove" listeners. ' + error);
        }
    }
};

provider.getUrl = function ( id, callback ) {
    core.backend.request('recordings/' + id + '/link', {
        version: 3,
        method: 'GET',
        onload: function ( error, response ) {
            if ( error ) {
                try {
                    response = JSON.parse(response).message;
                } catch ( parseError ) {
                    response = parseError;
                }
                //console.log(response);

                callback({
                    code: Client.prototype.errors.SERVER_ERROR,
                    message: Client.prototype.errorCodes[Client.prototype.errors.SERVER_ERROR]
                });
            } else if ( response.data && response.data.url ) {
                console.log('spvr->get->url:' + response.data.url);
                callback(null, response.data.url);
            } else {
                callback({
                    code: Client.prototype.errors.SERVER_ERROR,
                    message: Client.prototype.errorCodes[Client.prototype.errors.SERVER_ERROR]
                });
            }
        },
        onerror: function () {
            callback({
                code: Client.prototype.errors.SERVER_ERROR,
                message: Client.prototype.errorCodes[Client.prototype.errors.SERVER_ERROR]
            });
        }
    });
};

provider.init = function ( api, callback ) {
    this.api = api;

    providerDaemon.client = new Client();
    providerDaemon.client.enabled = true;
    providerDaemon.isActive = true;

    providerDaemon.client.update(function () {
        callback({
            provider: provider,
            data: daemon.list.map(function ( item ) {
                var wrapped = new Emitter();

                wrapped.id = item.id;
                wrapped.layout = apiConst.layouts.record;
                wrapped.geometry = apiConst.geometry.horizontal;
                wrapped.data = {
                    name: item.name,
                    progress: item.progress,
                    state: stateToText[item.state],
                    url: function ( getUrlCallback ) {
                        provider.getUrl(item.id, getUrlCallback);
                    },
                    mime: 'content/video'
                };

                providerDaemon.idToIndexHash[item.id] = wrapped;
                providerDaemon.list.push(wrapped);

                return wrapped;
            })
        });
    });
};

provider.search = function ( text, callback ) {
    callback(false, providerDaemon.list.map(function ( item ) {  // eslint-disable-line
        if ( item.data.name.indexOf(text) !== -1 ) {
            return item;
        }
    }));
};


module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = gettextWrapper.gettext;
            stateToText = ['', gettext('Scheduled recording'), gettext('Recording'), gettext('Recording error!'), gettext('Recorded')];
            callback();
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, new Client());
    },
    onContentBoardInit: function ( config, callback ) {
        provider.init(config.api, function ( data ) {
            callback(null, data);
        });
    }
};
